import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// API
import * as API  from '../../../../utils/api'

// Components
import FormContainer from '../../../../components/Global/FormContainer'
import SeasonForm from '../../../../components/UserPortal/Locker/Stats/SeasonForm'
import SeasonSelect from '../../../../components/UserPortal/Locker/Stats/SeasonSelect'
import GameForm from '../../../../components/UserPortal/Locker/Stats/GameForm'
import GameSelect from '../../../../components/UserPortal/Locker/Stats/GameSelect'
import AppCanvasLoader from '../../../../components/Global/AppCanvasLoader'
import FlashMessage from '../../../../components/Global/FlashMessage'

const earliestPlayedGame = (games) => (
  games.length === 0 ? null : games.reduce((earliest, current) => (
    earliest.played_on < current.played_on ? earliest : current
  ))
)

class LockerStats extends Component {
  static propTypes = {
    participation: PropTypes.object,
    updateParticipation: PropTypes.func.isRequired,

    // from redux
    user: PropTypes.object
  }

  state = {
    loading: true,
    addingSeason: false,
    activeSeasonID: null,
    activeGameID: null,
    previousActiveGameId: null,
    flashMessage: {
      type: '',
      message: ''
    },
  }

  componentWillReceiveProps(nextProps) {
    const { activeSeasonID, activeGameID } = this.state
    const { participation } = nextProps

    if (participation) {
      const firstSeason = participation.seasons[0]
      const firstSeasonID = firstSeason && firstSeason.id

      const seasonGames = activeSeasonID
        ? this.getActiveSeason().games
        : (firstSeason && firstSeason.games)

      const activeGameToBe = seasonGames && earliestPlayedGame(seasonGames)

      const nextState = {
        loading: false,
        addingSeason: (participation.seasons.length === 0),
        activeSeasonID: activeSeasonID || firstSeasonID,
        activeGameID: activeGameID || (activeGameToBe && activeGameToBe.id)
      }

      this.setState(nextState)
    }
  }

  engageAddingSeasonMode = () => {
    this.setState({addingSeason: true}, this.setFlashMessage('', ''))
  }

  disengageAddingSeasonMode = () => this.setState({addingSeason: false})

  engageAddingGameMode = () => this.setState({
    activeGameID: null,
    previousActiveGameId: this.state.activeGameID
  }, this.setFlashMessage('', ''))

  disengageAddingGameMode = () => this.setState({
    activeGameID: this.state.previousActiveGameId,
    previousActiveGameId: null
  })

  createSeason = (seasonData) => {
    const { user, participation, updateParticipation } = this.props
    const { season } = seasonData

    let seasonForSubmit = {
      school_id: season.school.id,
      starts_on: season.starts_on.format('YYYY-MM-DD'),
      ends_on: season.ends_on.format('YYYY-MM-DD')
    }

    API.createSeason(user, participation.id, seasonForSubmit)
    .then(season => {
      this.setFlashMessage('', 'Season added successfully.')
      updateParticipation()
      .then(() => this.setActiveSeason(season))
    })
  }

  setActiveSeason = (season) => {
    const activeGameToBe = earliestPlayedGame(season.games)

    const activeSeasonID = season.id
    const activeGameID = activeGameToBe ? activeGameToBe.id : null

    this.setState({activeSeasonID, activeGameID})
  }

  getActiveSeason = () => {
    const { seasons } = this.props.participation
    const { activeSeasonID } = this.state

    const activeSeason = seasons.find(season => season.id === activeSeasonID)

    return activeSeason
  }

  createGame = (gameData) => {
    const { user, updateParticipation } = this.props
    const { activeSeasonID } = this.state

    API.createGame(user, activeSeasonID, gameData)
    .then(game => this.setState({
        activeGameID: game.id
      }, () => updateParticipation().then(this.handleSuccessfulSave)
    ))
  }

  updateGame = (gameData) => {
    const { user } = this.props
    const { activeGameID } = this.state

    API.updateGame(user, activeGameID, gameData)
    .then(this.props.updateParticipation)
    .then(this.handleSuccessfulSave)
  }

  handleSuccessfulSave = () => {
    window.scrollTo(0, 0)
    this.setFlashMessage('', 'Your changes have been saved successfully.')
  }

  setActiveGame = (game) => this.setState({activeGameID: game.id})

  getActiveGame = () => {
    const { activeGameID } = this.state

    if (!activeGameID) return null

    const activeGame = this.getActiveSeason().games.find(game => {
      return game.id === activeGameID
    })

    return activeGame
  }

  formFormattedActiveGame = () => {
    const activeGame = this.getActiveGame()

    if (activeGame) {
      return {
        played_on: activeGame.played_on,
        description: activeGame.description,
        location: activeGame.location,
        played_position_ids: activeGame.played_positions.map(p => p.id),
        player_stats: activeGame.player_stats
      }
    }
  }

  setFlashMessage(type, message) {
    this.setState({
      flashMessage: {
        type,
        message
      }
    })
  }

  renderFlashMessage() {
    const { flashMessage } = this.state

    return flashMessage.message.length > 0
    ? (
      <FlashMessage optionalClasses={flashMessage.type}>
        {flashMessage.message}
      </FlashMessage>
    )
    : ''
  }

  render() {
    const { loading, addingSeason, activeSeasonID, activeGameID } = this.state
    const { participation } = this.props

    const { trial_active, on_trial } = this.props.activeProfile.trial_info
    const isLocked = on_trial && !trial_active

    if (loading) {
      return(
        <FormContainer optionalClassName="locker-stats">
          <AppCanvasLoader />
        </FormContainer>
      )
    }

    if (addingSeason) {
      return(
        <FormContainer optionalClassName="locker-stats adding-season" isLocked={isLocked}>
          <header>
            <h2>Add a Season</h2>
          </header>
          <SeasonForm
            participationID={participation.id}
            onSubmit={this.createSeason}
            allowCancel={!!activeSeasonID}
            onCancel={this.disengageAddingSeasonMode}
          />
        </FormContainer>
      )
    }
    // DO i need to lock this as well as adding a season?
    return (
      <FormContainer optionalClassName="locker-stats" isLocked={isLocked}>
        <header>
          <h2>Stats</h2>
        </header>
        {this.renderFlashMessage()}
        <div className="locker-stats-content">
          <div className="locker-stats-aside">
            <SeasonSelect
              seasons={participation.seasons}
              activeSeasonID={activeSeasonID}
              setActiveSeason={this.setActiveSeason}
              handleCtaClick={() => this.engageAddingSeasonMode()}
            />
            <hr/>
            <GameSelect
              games={this.getActiveSeason().games}
              activeGameID={activeGameID}
              setActiveGame={this.setActiveGame}
              handleCtaClick={() => this.engageAddingGameMode()}
            />
          </div>
          <div className="locker-stats-game-form-container">
            <GameForm
              seasonID={activeSeasonID}
              sportID={participation.sport.id}
              onSubmit={activeGameID ? this.updateGame : this.createGame}
              gameID={activeGameID}
              game={this.formFormattedActiveGame()}
              firstGame={this.getActiveSeason().games.length === 0}
              handleCancelClick={() => this.disengageAddingGameMode()}
            />
          </div>
        </div>
      </FormContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
   activeProfile: state.activeProfile
})

export default connect(mapStateToProps)(LockerStats)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerStats.js